import { payload } from "../../../../../node_modules/@sveltejs/kit/src/runtime/client/payload.js";
const env = payload.env;

export const PUBLIC_API_BASE_URL = "https://api2.reservatoo.com";
export const PUBLIC_WS_BASE_URL = "https://ws.reservatoo.com";
export const PUBLIC_STRIPE_KEY = "pk_live_51JcXfeDFLhoRptGiorcJt56VDcsN22p4P5vpHkUqiWjWJhGm1XVX6UoEADUMmdyLA1uRoyHKWqUfL9WU5k9Z4Pvj00rnLx0ufn";
export const PUBLIC_GOOGLE_CLIENT_ID = "890553008384-d445jcp7bsec8g9ba9o7jti218tgvtbr.apps.googleusercontent.com";
export const PUBLIC_FIREBASE_API_KEY = "AIzaSyASrGFR9w3oazXCJ0hwXZKq87EhgxZwam4";
export const PUBLIC_FIREBASE_APP_ID = "1:1029799151102:web:751667d9e82ba73a44acaf";
export const PUBLIC_FIREBASE_MEASUREMENT_ID = "G-D10TGT6ZYK";
export const PUBLIC_FIREBASE_MESSAGING_SENDER_ID = "1029799151102";
export const PUBLIC_FIREBASE_PROJECT_ID = "reservatoo-app";
export const PUBLIC_FIREBASE_VAPID_KEY = "BJmkq5D62bZAb6jQt0rIBhf2TlnJDoM7vzHqsdFThOWTCqFCAUMmjl31xedep7-cR0WyqaI3M9Ghbnzw3H5D0w8";
